import { render, staticRenderFns } from "./CardProfissional.vue?vue&type=template&id=3785552d&scoped=true&"
import script from "./CardProfissional.vue?vue&type=script&lang=js&"
export * from "./CardProfissional.vue?vue&type=script&lang=js&"
import style0 from "./CardProfissional.vue?vue&type=style&index=0&id=3785552d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3785552d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3785552d')) {
      api.createRecord('3785552d', component.options)
    } else {
      api.reload('3785552d', component.options)
    }
    module.hot.accept("./CardProfissional.vue?vue&type=template&id=3785552d&scoped=true&", function () {
      api.rerender('3785552d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/SelecaoAssinatura/components/cards/investidor/CardProfissional.vue"
export default component.exports